import React from "react";

const OnboardRole = ({
  width = 88,
  height = 88,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 88 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="87"
        height="87"
        rx="43.5"
        fill="url(#paint0_linear_1050_34979)"
      />
      <rect
        x="0.5"
        y="0.5"
        width="87"
        height="87"
        rx="43.5"
        stroke="url(#paint1_linear_1050_34979)"
      />
      <g filter="url(#filter0_d_1050_34979)">
        <rect x="16" y="16" width="56" height="56" rx="28" fill="white" />
        <rect
          x="16.5"
          y="16.5"
          width="55"
          height="55"
          rx="27.5"
          stroke="#E2E4E9"
        />
        <path
          d="M43.9996 46.0992V54.4992H35.5996C35.5996 52.2714 36.4846 50.1348 38.0599 48.5595C39.6352 46.9842 41.7718 46.0992 43.9996 46.0992ZM43.9996 45.0492C40.5189 45.0492 37.6996 42.23 37.6996 38.7492C37.6996 35.2685 40.5189 32.4492 43.9996 32.4492C47.4804 32.4492 50.2996 35.2685 50.2996 38.7492C50.2996 42.23 47.4804 45.0492 43.9996 45.0492ZM46.7244 51.1518C46.5912 50.5916 46.5912 50.0079 46.7244 49.4477L45.6828 48.846L46.7328 47.0274L47.7744 47.6291C48.1924 47.2331 48.6978 46.941 49.2496 46.7765V45.5742H51.3496V46.7765C51.9082 46.9424 52.4122 47.2385 52.8249 47.6291L53.8665 47.0274L54.9165 48.846L53.8749 49.4477C54.0078 50.0076 54.0078 50.5909 53.8749 51.1508L54.9165 51.7524L53.8665 53.571L52.8249 52.9694C52.4068 53.3653 51.9014 53.6574 51.3496 53.822V55.0242H49.2496V53.822C48.6978 53.6574 48.1924 53.3653 47.7744 52.9694L46.7328 53.571L45.6828 51.7524L46.7244 51.1518ZM50.2996 49.2492C50.0211 49.2492 49.7541 49.3598 49.5571 49.5568C49.3602 49.7537 49.2496 50.0207 49.2496 50.2992C49.2496 50.5777 49.3602 50.8448 49.5571 51.0417C49.7541 51.2386 50.0211 51.3492 50.2996 51.3492C50.5781 51.3492 50.8452 51.2386 51.0421 51.0417C51.239 50.8448 51.3496 50.5777 51.3496 50.2992C51.3496 50.0207 51.239 49.7537 51.0421 49.5568C50.8452 49.3598 50.5781 49.2492 50.2996 49.2492Z"
          fill="#525866"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1050_34979"
          x="12"
          y="14"
          width="64"
          height="64"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.105882 0 0 0 0 0.109804 0 0 0 0 0.113725 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1050_34979"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1050_34979"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1050_34979"
          x1="44"
          y1="0"
          x2="44"
          y2="88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4E5E7" stopOpacity="0.48" />
          <stop offset="1" stopColor="#F7F8F8" stopOpacity="0" />
          <stop offset="1" stopColor="#E4E5E7" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1050_34979"
          x1="44"
          y1="0"
          x2="44"
          y2="88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4E5E7" />
          <stop offset="0.765625" stopColor="#E4E5E7" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default OnboardRole;
